export const RPS_EMITIDOS = 'Conta Corrente de Cliente';
export const INFORMACAO_EXTRA = 'Adicionar Informação Extra';
export const RPS_DIALOG = 'RPS Emitidos > ';
export const INFORMACAO_COMPLEMENTAR = 'Adicionar Informação Complementar';
